import type { RequestFunctionParams } from "yapi-to-typescript";
import {
  request as commonRequest,
  RequestConfig as commonRequestConfig,
} from "@/service/request";
import { ewodHost } from "@/config/host";
export interface RequestOptions {
  /**
   * 使用的服务器。
   *
   * - `prod`: 生产服务器
   * - `dev`: 测试服务器
   * - `mock`: 模拟服务器
   *
   * @default prod
   */
  server?: "prod" | "dev" | "mock";
}

export default function request<TResponseData>(
  payload: RequestFunctionParams
): Promise<TResponseData> {
  // 请求地址
  const url = `${ewodHost}${payload.path}`;
  // 具体请求逻辑
  const reqConf: commonRequestConfig = {
    url,
    method: payload.method || "GET",
  };
  if (reqConf.method?.toLowerCase() === "get") {
    reqConf.params = payload.data;
  } else {
    reqConf.data = payload.data;
  }
  return commonRequest(reqConf);
}
